export default "__VITE_ASSET__Dxqu77tu__"